<div class="modal fade" id="kbaCommentViewModal" tabindex="-1" role="dialog" aria-labelledby="kbaCommentViewModalLabel"
    aria-hidden="true">

    <div class="modal-dialog" role="document">
        <div class="modal-content col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 pr-0 pl-0">
            <div class="kba-comment-header col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                {{'KbaComments.kbacomments' | translate}}
                <button id='commentDissmissButton' type="button " class="close" data-dismiss="modal"
                    (click)='dismisskbaCommentViewModal()' aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12" id="kbaCommentViewModalBody">
            <div class="col-12">
                <div class="comments">
                  <div *ngFor='let comment of kbaCommentsList' class="m-2">
                    <div class="head">
                      <p class="name">{{comment.owner.fullName}}</p>&nbsp;&nbsp;<p>|</p>&nbsp;&nbsp;
                      <p class="number">{{comment.owner.email}}</p>
                    </div>
                    <div class="note-box">
                      <div *ngIf='comment.parentId'>
                          <div *ngIf='kbaCommentMap.get(comment.parentId); else elseBlock' class="note-box-header"
                          (click)='moveToParentComment(comment.parentId)'>
                              <div class="in-reply">
                                <p>  {{'KbaComments.inreplyto' | translate}}</p>
                                <p class="original-name"> &nbsp;&nbsp;{{kbaCommentMap.get(comment.parentId).owner.fullName}}&nbsp;&nbsp;</p>
                                <p class="original-note">&nbsp;&nbsp;{{kbaCommentMap.get(comment.parentId).commentText}}</p>
                              </div>
                        </div>
                        <ng-template #elseBlock>
                          <div class="note-box-header">
                            <div class="in-reply">
                              <p>  {{'KbaComments.inreplyto' | translate}}</p>
                              <p class="original-note">&nbsp;&nbsp;   {{'KbaComments.irrelevantcomment' | translate}}</p>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="actual-note" [attr.id]=comment.id>
                         {{comment.commentText}}
                      </div>
                    </div>
                    <div class="footer">
                      <a class='reply-conversation' (click)='replyToComment(comment)'> {{'KbaComments.reply' | translate}}</a>
                      <div class="timing">{{comment.commentDate}}</div>
                    </div>
                  </div>
                  </div>
            </div>    
           
            <div class="col-12 mt-4">
              <p *ngIf='!replyToLabelFlag' class="newandreplycommentlabel"> {{'KbaComments.newcomment' | translate}}
                <span style="float:right;">
                  <em class="fa fa-redo" (click)="clearComment()" data-toggle="tooltip" title="{{'KbaComments.clear' | translate}}"></em>
                  </span>
              </p>
              <p *ngIf='replyToLabelFlag' class="newandreplycommentlabel"> {{'KbaComments.inreplyto' | translate}}: &nbsp; {{parentCommentName}} 
                <span style="float:right;">
                  <em class="fa fa-redo" (click)="clearComment()" data-toggle="tooltip" title="{{'KbaComments.clear' | translate}}"></em>
                  </span>
              </p>
              <textarea id="newandreplycomment" [(ngModel)]="kbaCommentText"></textarea>
          </div>     
            <div class="modal-footer">
              <button type="button" class="btn btnclose kbacommentbutton" data-dismiss="modal"
                  (click)="dismisskbaCommentViewModal()"> {{'KbaComments.close' | translate}}</button>
              <button type="button" class="btn btn-primary kbacommentbutton"
                  (click)="addKbaComment()" [disabled]="kbaCommentText === ''"> {{'KbaComments.add' | translate}}</button>
          </div>
            </div>
        </div>
    </div>
</div>
